import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import Button from '@mui/material/Button'
import StyledLink from '../StyledLink'
import { approveWhitelistedEmailDomainById, denyWhitelistedEmailDomain, showModal } from '../../redux/actions'

export function DomainActionButton({ domain }) {
  const dispatch = useDispatch()

  const [processing, setProcessing] = useState(false)

  const onApproveWhitelistedEmailDomainById = (id) => {
    setProcessing(true)
    dispatch(approveWhitelistedEmailDomainById(id)).then(() => setProcessing(false))
  }
  const rejectDomain = (id) => {
    setProcessing(true)
    dispatch(denyWhitelistedEmailDomain(id)).then(() => setProcessing(false))
  }
  const onDeleteTouchTap = () => {
    dispatch(showModal('DELETE_WHITELISTED_DOMAIN', { domain }))
  }

  return (
    <div style={{ margin: '3px 0' }}>
      {domain
    && domain.approvalStatus === 'Approved' && (
      <StyledLink key="remove" onClick={onDeleteTouchTap} clickHandlerOnly contents="Remove" styles={{ color: '#f44336' }} />
      )}

      {domain.approvalStatus === 'Pending' && (
      <div>
        <Button
          key="reject"
          label="Reject"
          disabled={processing}
          size="small"
          variant="contained"
          color="secondary"
          onClick={() => rejectDomain(domain.id)}
          style={{ margin: '4px' }}
        >
          Reject
        </Button>
        <Button
          key="approve"
          label="Approve"
          disabled={processing}
          size="small"
          color="primary"
          variant="contained"
          onClick={() => onApproveWhitelistedEmailDomainById(domain.id)}
          style={{ margin: '4px' }}
        >
          Approve
        </Button>
      </div>
      )}
    </div>
  )
}

DomainActionButton.propTypes = {
  domain: PropTypes.shape({
    id: PropTypes.number,
    approvalStatus: PropTypes.string,
  }).isRequired,
}

export default DomainActionButton
